import {
  Box,
  CircularProgress,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@material-ui/core"
import { ReactComponent as Logo } from "assets/matchboard-logo.svg"
import ButtonRounded from "components/Common/ButtonRounded"
import ConditionalDialogWrapper from "components/Common/ConditionalDialogWrapper"
import AppContext from "contexts/App"
import { useContext } from "react"

import useStyles from "./styles"

const EmailVerification = () => {
  const classes = useStyles()

  const { dialogs, closeDialog } = useContext(AppContext)
  const thisDialog = dialogs?.["emailVerification"] || {}
  const { open = false, data = {} } = thisDialog
  let subtitle = thisDialog?.data?.subtitle

  const handleClose = () => {
    closeDialog("emailVerification")
  }

  return (
    <ConditionalDialogWrapper open={open} onClose={handleClose}>
      <DialogTitle disableTypography>
        <Box display="flex" justifyContent="center">
          <Logo className={classes.logo} />
        </Box>
      </DialogTitle>

      <DialogContent>
        {subtitle === "" ? (
          <Box display="flex" justifyContent="center">
            <CircularProgress size={20} />
          </Box>
        ) : (
          <Typography color="primary" variant="h2" className={classes.title}>
            {subtitle}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Box display="flex" justifyContent="center" width="100%">
          <ButtonRounded
            color="primary"
            variant="outlined"
            onClick={handleClose}
            type="button"
            data-cy="education-close-button"
          >
            Close
          </ButtonRounded>
        </Box>
      </DialogActions>
    </ConditionalDialogWrapper>
  )
}

export default EmailVerification
